/**
 * The short post-incident report asked when something is marked fixed: what caused it (one tap),
 * and, optionally, what was done. Both are optional — "Mark fixed" works without them. Used by the
 * System problems list and by the alert record's Resolve dialog.
 */
import { RESOLUTION_CAUSES } from './alertActionsModel';

export interface ResolveReportValue {
  cause: string;
  note: string;
}

export default function ResolveReport({ value, onChange, notePlaceholder = 'What was done? (optional)' }: {
  value: ResolveReportValue;
  onChange: (v: ResolveReportValue) => void;
  notePlaceholder?: string;
}) {
  return (
    <div className="space-y-2">
      <div>
        <p className="mb-1 text-[12px] font-medium text-muted-foreground">What caused it?</p>
        <div className="flex flex-wrap gap-1.5">
          {RESOLUTION_CAUSES.map((c) => (
            <button
              key={c.value}
              type="button"
              aria-pressed={value.cause === c.value}
              onClick={() => onChange({ ...value, cause: value.cause === c.value ? '' : c.value })}
              className={`rounded-lg border px-2.5 py-1 text-[12px] ${value.cause === c.value ? 'border-brand bg-brand-light font-medium text-brand' : 'border-border text-foreground hover:bg-muted'}`}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>
      <textarea
        value={value.note}
        onChange={(e) => onChange({ ...value, note: e.target.value })}
        placeholder={notePlaceholder}
        rows={2}
        maxLength={2000}
        className="w-full rounded-lg border border-border bg-background px-2.5 py-1.5 text-[13px] text-foreground placeholder:text-muted-foreground"
      />
    </div>
  );
}
